import { render, staticRenderFns } from "./EditProfileModal.vue?vue&type=template&id=6369beb8&"
import script from "./EditProfileModal.vue?vue&type=script&lang=js&"
export * from "./EditProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports